module.exports = __webpack_public_path__ + "img/private-napolimania-meat-1.99d366a9.jpg";